export const BackDropConstants = {
    START: 'START',
    END: 'END'
};